
import { defineComponent } from 'vue'
import service from '@/service'

export default defineComponent({
  data: () => ({
    qrSvg: ''
  }),
  created() {
    service
      .getQRCode()
      .then(({ svg }) => {
        this.qrSvg = svg
      })
      .catch(console.error)
  }
})
